/*Temos varios padroes diferentes que podem ser usados na organizacao, por padrao sempre criamos 
uma pasta components, no caso criamos um PostCard. O arquivo index pode ser em formato JSX ou JS, no caso usaremos JSX
*/
import './styles.css'
export const PostCard = ({title, cover,body, id}) =>   //fiz o destructing (const post = props.post)
( //pode elliminar a palavra return
  <div className="post">
    <img src={cover} alt={title} />
    <div className="post-content"> 
      <h1 >{title} {id}</h1>
      <p>{body}</p>
    </div>
  </div>
  )
